<template>
  <el-dialog
    v-loading="isLoading"
    :title="title"
    :visible.sync="dialogFormVisible"
    top="8vh"
    width="600px"
    element-loading-text="加载中"
    @close="close"
  >
    <el-form
      v-if="dialogFormVisible"
      ref="form"
      :model="form"
      :rules="rules"
      label-width="100px"
    >
      <!-- 所属状态 -->
      <!-- 退款方式 -->
      <el-form-item
        v-if="form.gtype == 2"
        label="退款方式"
        prop="refund_type"
        style="margin-bottom: 15px"
      >
        <el-radio-group v-model="form.refund_type">
          <el-radio :label="0">全额退款</el-radio>
          <el-radio v-if="bufen_refund" :label="1">部分退款</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        v-if="form.gtype == 2"
        label="退款商品"
        prop="refund_type"
        style="margin-bottom: 15px"
      >
        <div
          v-for="(item, index) in tui_goods_spec_list"
          :key="index"
          class="tui_sku_class"
        >
          <img :src="item.pic" alt="" style="width: 80px; height: 80px" />
          <div class="tui_sku_class_right">
            <span>规格：{{ item.sku }}</span>
            <span>数量：{{ item.num }}</span>
            <span>价格：{{ item.price }}</span>
          </div>
        </div>
      </el-form-item>
      <el-form-item
        label="退款积分"
        prop="point_tui"
        style="margin-bottom: 15px"
      >
        <el-input
          v-model="form.point_tui"
          type="text"
          show-word-limit
          maxlength="15"
          :placeholder="placeholder_point"
          @input="inputPointChange"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="退款金额"
        prop="price_tui"
        style="margin-bottom: 15px"
      >
        <el-input
          v-model="form.price_tui"
          type="text"
          show-word-limit
          maxlength="10"
          :placeholder="placeholder"
          @input="inputChange"
        ></el-input>
      </el-form-item>
      <el-form-item label="申请原因" prop="dsc">
        <el-input
          v-model="form.dsc"
          show-word-limit
          type="textarea"
          maxlength="50"
          placeholder="请输入申请原因"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="save">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import {
    order_refund,
    GoodsOrder_refund_order_spec,
    orderRefundDetail,
  } from '@/api/xgcApi'
  export default {
    name: 'UserManagementEdit',
    components: {},
    props: {
      bufen_refund: {
        type: Boolean,
        default: true,
      },
    },
    data() {
      return {
        dialogFormVisible: false,
        isLoading: false,
        form: {
          refund_type: 0,
          price_tui: null, //退款金额
          dsc: '', //退款原因
          point_tui: null, //退款积分
        },
        title: '申请退款',
        placeholder: '',
        rules: {
          refund_type: [
            {
              required: true,
              validator: (rule, value, callback) => {
                if (value === '') {
                  callback(new Error('请选择退款方式'))
                } else {
                  callback()
                }
              },
              trigger: 'change',
            },
          ],
          price_tui: [
            {
              required: true,
              message: '请输退款金额',
              trigger: 'change',
            },
          ],
          point_tui: [
            {
              required: true,
              message: '请输退款积分',
              trigger: 'change',
            },
          ],
          dsc: [
            {
              required: true,
              message: '请输入',
              trigger: 'change',
            },
          ],
        },
        type: 1,
        price: [
          {
            required: true,
            trigger: 'blur',
            message: '请输入物品金额',
          },
        ],
      }
    },

    created() {},
    methods: {
      close() {
        this.dialogFormVisible = false
      },
      inputChange(e) {
        this.form.price_tui = this.$geShi(e)
        if (this.form.price_tui > this.form.price) {
          this.form.price_tui = this.max
        }
      },
      inputPointChange(e) {
        this.form.point_tui = this.$geShi(e)
        if (this.form.point_tui > this.form.deduction_points) {
          this.form.point_tui = this.form.deduction_points
        }
      },
      // 打开包裹退款详情
      open(row, type) {
        this.form = {
          ...this.form,
          ...row,
        }
        if (this.form.gtype == 2) {
          // 商品退款
          var data = {
            id: this.form.id,
          }
          GoodsOrder_refund_order_spec(data)
            .then((res) => {
              this.tui_goods_spec_list = res.data
              this.type = type
              this.max = Number(row.price) - Number(row.refund_price)
              this.max = this.max.toFixed(2)
              this.placeholder = `退团金额不能超过${this.max}元`
              var mo_total = 0
              this.tui_goods_spec_list.forEach((item, index) => {
                mo_total += Number(item.num) * Number(item.price)
              })
              this.form.price_tui = this.max
              this.form.dsc = ''
              this.dialogFormVisible = true
            })
            .catch((err) => {})
        } else {
          var data = {
            order_id: this.form.id,
          }
          this.type = type
          orderRefundDetail(data).then((res) => {
            if (res.data.pay_type == 1) {
              // 全积分支付
              this.max = '0.00'
              this.form.price = 0
              this.placeholder_point = `退团积分不能超过${this.form.deduction_points}积分`
              this.placeholder = `退团金额不能超过${this.max}元`
            } else {
              // 现金支付/现金积分混合支付
              this.max = Number(row.price) - Number(row.refund_price)
              this.max = this.max.toFixed(2)
              this.placeholder_point = `退团积分不能超过${this.form.deduction_points}积分`
              this.placeholder = `退团金额不能超过${this.max}元`
            }
            this.form.point_tui = null
            this.form.price_tui = null
            this.form.dsc = ''
            this.dialogFormVisible = true
          })
        }
      },
      save() {
        let row = this.form
        var date = {
          id: row.id,
          price:String(this.form.price_tui) ,
          point: this.form.point_tui,
          // type: this.type, //1正常包裹 2补拍 3代买 4代发 5代买商品
          refund_remarks: this.form.dsc, //退款理由
          refund_type: this.form.refund_type, //退款方式
        }
        if (row.gtype == 1) {
          delete date.refund_type
        }
        this.$refs['form'].validate((valid) => {
          if (valid) {
            this.isLoading = true
            order_refund(date)
              .then((res) => {
                this.$baseMessage('操作成功', 'success')
                this.$emit('change', true)
                this.dialogFormVisible = false
                this.isLoading = false
              })
              .catch((err) => {
                this.isLoading = false
              })
          } else {
            return false
          }
        })
      },
    },
  }
</script>
<style scoped>
  :deep .el-select > .el-input {
    width: 430px;
  }
  .tui_sku_class {
    border: 1px solid #ccc;
    border-radius: 10px;
    margin-bottom: 8px;
    padding: 8px 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .tui_sku_class_right {
    flex: 1;
    display: flex;
    flex-direction: column;
    margin-left: 16px;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>
